<template>
    <div class="address-fill">
        <van-action-sheet v-model="address.show" title="选择收货地址" :show-cancel-button="false" :show-confirm-button="false" :closeable="false">
            <div class="address-list" v-watermark>
                <div class="address-list-self" v-if="deliverType != 2">
                    <van-button color="#2a2b7d" size="small" round @click="onAddressDeliverTypeSet">设为用户自取</van-button>
                </div>
                <div class="address-list-box">
                    <div class="item" v-for="(item, index) in address.list" :key="index">
                        <div class="item-box" :class="{ active: defaults.name == item.name && defaults.phone == item.phone && defaults.address == item.address && deliverType == 1 }" @click="onAddressSet(item)">
                            <div class="txt">
                                <div class="head">
                                    <div class="cell name">{{ item.name }}</div>
                                    <div class="cell phone">{{ item.phone }}</div>
                                    <div class="cell default" v-if="item.isDefault == 1">默认</div>
                                </div>
                                <div class="foot">{{ item.province }}{{ item.city }}{{ item.area }}{{ item.address }}</div>
                            </div>
                            <div class="icon" @click.stop="onEditShow(item)">
                                <van-icon name="edit" />
                            </div>
                        </div>
                    </div>
                    <van-empty description="暂无地址" v-if="!address.loading && !address.list.length" />
                </div>
                <div class="address-list-btn">
                    <van-button color="#2a2b7d" round size="small" @click="onEditShow()">添加收货地址</van-button>
                </div>
            </div>
        </van-action-sheet>

        <van-dialog v-model="edit.show" :title="`${edit.id ? '编辑' : '添加'}地址`" :show-cancel-button="false" :show-confirm-button="false" :close-on-click-overlay="true">
            <div class="address-edit" v-watermark>
                <div class="address-edit-close" @click="edit.show = false">
                    <van-icon name="cross" />
                </div>
                <van-form @submit="onSubmit" @failed="onValidFailed" :show-error-message="false" label-width="5em" ref="editFormRef">
                    <van-field key="name" v-model="edit.name" label="收货人" placeholder="请输入收货人" :rules="[{ required: true, message: '请输入收货人' }]" />
                    <van-field key="phone" v-model="edit.phone" label="收货电话" placeholder="请输入收货电话" :rules="[{ required: true, message: '请输入收货电话'}, {validator: onEditPhoneValid, message: '电话号码不正确'}]" />
                    <van-field key="region" name="region" label="所在区域" :rules="[{ required: !edit.region.length, message: '请选择所在区域' }]">
                        <template #input>
                            <div class="selected" @click="onRegionShow">
                                <span>{{ edit.region.length ? edit.region.join(' ') : '请选择' }}</span>
                                <van-icon name="arrow" />
                            </div>
                        </template>
                    </van-field>
                    <van-field key="address" v-model="edit.address" label="详细地址" placeholder="请输入详细地址" :rules="[{ required: true, message: '请输入详细地址' }]" />
                    <van-field key="isDefault" name="isDefault" label="设为默认">
                        <template #input>
                            <van-switch v-model="edit.isDefault" :active-value="1" :inactive-value="0" size="24px" active-color="#2a2b7d" />
                        </template>
                    </van-field>
                    <div class="btn">
                        <van-button color="#2a2b7d" size="small" round>保存</van-button>
                    </div>
                </van-form>
            </div>
        </van-dialog>
        <van-action-sheet v-model="region.show">
            <van-area :value="edit.addressCode" :area-list="edit.areaList" @confirm="onRegionConfirm" @cancel="onRegionCancel" v-if="region.show" />
        </van-action-sheet>
    </div>
</template>
<script>
import { areaList } from "@vant/area-data";
import { validPhone } from '@/hooks/valid'
import { onEncode } from '@/hooks/api'
import request from '@/utils/request.js'
export default {
    name: 'address-fill',
    components: {

    },
    props: {
        defaults: {
            type: Object,
            default: () => ({})
        },
        deliverType: {
            type: Number,
            default: 1
        },
        askNo: {
            type: String | Number,
            defaut: ''
        },
        userNo: {
            type: String | Number,
            defaut: ''
        }
    },
    data() {
        return {
            address: {
                show: false,
                submit: true,
                loading: false,
                list: []
            },
            edit: {
                show: false,
                submit: true,
                id: '',
                name: '',
                phone: '',
                addressCode: '',
                region: [],
                address: '',
                isDefault: 0,
                areaList: areaList
            },
            region: {
                show: false
            }
        }
    },
    computed: {

    },
    mounted() {
        
    },
    destroyed() {

    },
    methods: {
        onEditPhoneValid(val) {
            return validPhone(val);
        },
        onEditShow(row = {}) { // 编辑
            // 地区默认赋值
            let addressCode = '';
            let region = [];
            if (row.province && row.city && row.area) {
                region = [row.province, row.city, row.area]
                let province = this.onObjectFindKey(areaList.province_list, row.province)
                if (province) {
                    let city = this.onObjectFindKey(areaList.city_list, row.city, province.toString().substring(0, 2));
                    if (city) {
                        let area = this.onObjectFindKey(areaList.county_list, row.area, city.toString().substring(0, 4));
                        if (area) {
                            addressCode = area;
                        }
                    }
                }
            }
            this.edit.addressCode = addressCode;
            this.edit.region = region;
            this.edit.id = row.id || '';
            this.edit.name = row.name || '';
            this.edit.phone = row.phone || '';
            this.edit.address = row.address || '';
            this.edit.isDefault = row.isDefault || 0;
            this.edit.show = true;
            this.$refs.editFormRef && this.$refs.editFormRef.resetValidation()
        },
        onObjectFindKey(obj, val, key) {
            for (let k in obj) {
                if (obj[k] === val && !(key && key.toString().indexOf(k.toString().substring(0, key.length)) != 0)) return k;
            }
            return '';
        },
        onSubmit() {
            if (!this.edit.submit) return false;
            let form = this.edit;
            let send = {
                id: form.id || '',
                name: form.name,
                phone: form.phone,
                address: form.address,
                province: form.region[0],
                city: form.region[1],
                area: form.region[2],
                isDefault: form.isDefault,
                userNo: this.userNo
            }
            this.$refs.editFormRef.validate().then(() => {
                return request({
                    url: send.id ? '/user-service/app/userInfo/addressUpdate' : '/user-service/app/userInfo/addressAdd',
                    method: 'post',
                    data: onEncode(send).join('&'),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
            }).then(() => {
                this.$toast('保存成功');
                this.edit.show = false;
                this.onAddressSet(send)
            }).catch(() => {
                
            })
        },
        onValidFailed({errors = []}) { // 验证失败
            if(errors.length) {
                this.$toast(errors[0].message);
            }
        },
        onRegionShow() {
            this.onRegionSet();
            this.region.show = true;
        },
        onRegionSet() { // 地区默认赋值
            let addressCode = '';
            let [p, c, a] = this.edit.region;
            if (p && c && a) {
                let province = this.onObjectFindKey(areaList.province_list, p)
                if (province) {
                    let city = this.onObjectFindKey(areaList.city_list, c, province.toString().substring(0, 2));
                    if (city) {
                        let area = this.onObjectFindKey(areaList.county_list, a, city.toString().substring(0, 4));
                        if (area) {
                            addressCode = area;
                        }
                    }
                }
            }
            this.edit.addressCode = addressCode;
        },
        onRegionConfirm(arr) {
            this.edit.region = arr.map((itm) => itm.name);
            this.$refs.editFormRef.resetValidation('region')
            this.region.show = false;
        },
        onRegionCancel() {
            this.region.show = false;
        },
        onAddressGet() { // 地址获取
            return new Promise((resolve, reject) => {
                this.address.loading = true;
                request({
                    url: '/user-service/app/userInfo/addressList',
                    method: 'get',
                    params: {
                        userNo: this.userNo
                    }
                }).then(({ data }) => {
                    this.address.list = data || [];
                    this.address.loading = false;
                    resolve(true);
                }).catch(() => {
                    this.address.loading = false;
                    reject(false);
                })
            })
        },
        onAddressSet(row) {
            if (!this.address.submit) return false;
            this.$toast.loading({
                duration: 0,
                message: '地址设置中...',
                forbidClick: true
            });
            this.address.submit = false;
            request({
                method: 'put',
		        url: `/user-service/doctormg/askinfo/modifyAddress/${this.askNo}`,
                data: {
                    id: row.id,
                    name: row.name,
                    phone: row.phone,
                    address: row.address,
                    province: row.province,
                    city: row.city,
                    area: row.area,
                    street: row.street || '',
                    deliverType: 1
                }
            }).then(() => {
                this.address.submit = true;
                this.$toast.clear();
                this.address.show = false;
                this.$emit('success');
            }).catch(() => {
                this.address.submit = true;
                this.$toast.clear();
            })
        },
        onAddressDeliverTypeSet() {
            if (!this.address.submit) return false;
            this.$toast.loading({
                duration: 0,
                message: '自提设置中...',
                forbidClick: true
            });
            this.address.submit = false;
            request({
                url: `/user-service/doctormg/askinfo/modifyAddress/${this.askNo}`,
                method: 'put',
                data: {
                    deliverType: 2
                }
            }).then(() => {
                this.address.submit = true;
                this.$toast.clear();
                this.address.show = false;
                this.$emit('success');
            }).catch(() => {
                this.address.submit = true;
                this.$toast.clear();
            })
        },
        onAddressShow() {
            this.address.show = true;
        }
    },
    watch: {

    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";
$main-color: #2a2b7d;
.address-fill {
    #{$deep} .van-action-sheet__header {
        font-weight: bold;
    }
    #{$deep} .van-action-sheet {
        max-height: 100%;
    }
}
.address-list {
    padding-bottom: calc(env(safe-area-inset-bottom) /2);
    &-self {
        @include flex(center, center);
        margin-bottom: 20px;
        .van-button {
            padding: 0 30px;
        }
    }
    &-box {
        height: 60vh;
        overflow-y: auto;
        .item {
            margin: 20px 20px 0;
            &:first-child {
                margin-top: 0;
            }
            &-box {
                @include flex(center, space-between);
                border: 1px solid #eee;
                border-radius: 8px;
                padding: 15px 18px;
                cursor: pointer;
                .head {
                    display: flex;
                    align-items: center;
                    .cell {
                        &:not(:first-child) {
                            margin-left: 10px;
                        }
                        &.name,
                        &.phone {
                            font-weight: bold;
                        }
                        &.default {
                            background: $main-color;
                            color: #fff;
                            font-size: 12px;
                            padding: 0 5px;
                            border-radius: 4px;
                        }
                    }
                }
                .foot {
                    margin-top: 10px;
                    font-size: 16px;
                }
                .icon {
                    margin-left: 20px;
                    font-size: 24px;
                    padding: 10px;
                }
                &.active {
                    border-color: #d2d4df;
                    background: #f9fafe;
                }
            }
        }
    }
    &-btn {
        padding: 20px;
        .van-button {
            width: 100%;
        }
    }
}
.address-edit {
    position: relative;
    padding-top: 10px;
    &-close {
        position: absolute;
        right: 20px;
        top: -45px;
        cursor: pointer;
        color: #999;
    }
    .selected {
        flex: 1;
        padding-right: 10px;
        @include flex(center, space-between);
        .van-icon {
            color: #999;
        }
    }
    .btn {
        @include flex(center, center);
        padding: 20px;
        .van-button {
            flex: 1;
            margin: 0 10px;
        }
    }
    .van-field {
        background: transparent;
    }
}
</style>